export default "__VITE_ASSET__BEC2SP6___"